import { useSelector } from "react-redux";
import * as React from "react";

import { Activity, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { DefaultWidgetMap, WidgetMap } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/view";
import {
	TreeEngineActivity,
	TreeEngineFactories
} from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";

import { getViewHtmlId } from "../../focusHandling/sagas";

/**
 * Custom TreeEngine Komponente um einen Tree in einem Modal anzuzeigen.
 * Diese Komponente wird benutzt, wenn ein Text aus dem Textbaustein Baum
 * ausgesucht werden soll.
 */
export const CustomTreeEngine: View.ViewComponent = function CustomTreeEngine(props) {
	const ariaLevel = props.ariaLevel;
	const activityId = props.activityId;
	const activity = useSelector(ActivitySelectors.activityById(activityId));
	const dataHolder = Activity.findDefaultDataHolder(activity);
	const descriptor = dataHolder?.descriptor as
		(TreeEngineActivity.Descriptor.HiddenRootInstance & { rootName: string }) | undefined;
	const headingText = descriptor?.rootName ?? "Text aussuchen";

	const widgetMap: WidgetMap = React.useMemo(
		() => ({
			...DefaultWidgetMap,
			Title: props => {
				return <DefaultWidgetMap.Title {...props} ariaLevel={ariaLevel} text={headingText} />;
			},
			Button: props => {
				return <DefaultWidgetMap.Button {...props} disabled={false} />;
			},
			ContentBox: props => {
				return <DefaultWidgetMap.ContentBox {...props} id={getViewHtmlId(activityId)} />;
			}
		}),
		[ariaLevel, headingText, activityId]
	);

	return <TreeEngineFactories.ViewComponent {...props} widgetMap={widgetMap} />;
};
